import React from "react";

import rfreshIcon from "../../assets/Icons/New Icons/Refresh icon.png"

interface LoadingStateProps {
  message?: string;
  fullHeight?: boolean;
  size?: "small" | "medium" | "large";
  className?: string;
}

const LoadingState: React.FC<LoadingStateProps> = ({
  message = "Loading...",
  fullHeight = true,
  className = "",
}) => {
  return (
    <div
      className={`flex flex-col items-center justify-center gap-3 ${fullHeight ? "min-h-[400px]" : "py-12"
        } ${className}`}
      role="status"
      aria-live="polite"
    >
      <img src={rfreshIcon} alt="Refresh" className={"animate-spin w-8 h-8"} />

      {message && (
        <p className="text-sm text-muted-foreground/80 font-medium tracking-wide">
          {message}
        </p>
      )}
    </div>
  );
};

export default LoadingState;